import { ActivityIcon, FileSheetIcon, ClassIcon } from "@icons";
import { Command, CommandItem } from "@vendor/cmdk/cmdk";
import { FC, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useTypedFlags } from "@hooks/useTypedFlags";
import { useCommands } from "./useCommands";

export const WorkspaceCommandsList: FC = () => {
    const { close: closeCommands } = useCommands();
    const navigate = useNavigate();
    const { classes: canUseClasses } = useTypedFlags();

    const handleSelected = useCallback(
        (path: string) => {
            navigate(path);
            closeCommands();
        },
        [closeCommands, navigate],
    );

    return (
        <Command.Group heading="Workspace">
            <CommandItem
                keywords={["custom"]}
                onSelect={() => handleSelected("/categories")}
            >
                <ActivityIcon /> Go to Categories
            </CommandItem>

            <CommandItem
                keywords={["categorization", "category"]}
                onSelect={() => handleSelected("/rules")}
            >
                <FileSheetIcon /> Go to Rules
            </CommandItem>

            {canUseClasses && (
                <CommandItem onSelect={() => handleSelected("/classes")}>
                    <ClassIcon /> Go to Classes
                </CommandItem>
            )}
        </Command.Group>
    );
};
